import {Injectable} from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import {ApiService} from '../../services/api/api.service';
import {Store} from '@ngrx/store';
import {map} from 'rxjs/operators';
import {Observable} from 'rxjs';
import {whenLoaded} from '../when-loaded';
import {UntilDestroy} from '@ngneat/until-destroy';
import {CurrentAccountState} from '../../ngrx/states/current-account-state';
import {CurrentAccountSelector} from '../../ngrx/selectors/current-account-selector';

@UntilDestroy()
@Injectable()
export class LoggedInRouteGuard  {
  constructor(private api: ApiService,
              private router: Router,
              private currentAccountStateStore: Store<CurrentAccountState>) {
  }

  public canActivate(): Observable<boolean | UrlTree> {
    return whenLoaded(this, this.currentAccountStateStore, CurrentAccountSelector)
      .pipe(map(state => state.account))
      .pipe(map(account => {
        if (account != null) {
          return true;
        } else {
          return this.router.parseUrl('/');
        }
      }));
  }
}
